import { Module } from "vuex";

export interface LenderBranding {
  brandedWebsiteUrl: string;
  displayName: string;
  emailAddress: string;
  image: string;
  lenderId: number;
  name: string;
  primaryColor: string;
  secondaryColor: string;
  subDomain: string;
  tollFreeNumber: string;
	zohoSalesIQChatEnabled: boolean;
}

export interface UserApplication {
  applicationId: number;
  applicationStatusAtUtc: Date | string;
  applicationStatusId: number;
  applicationStatusName: string;
  applicationTypeName: string;
  created: Date | string;
  expires: Date | string;
  lenderId: number;
  productTypeId: number;
  programTypeId: number;
  referenceId: string;
  subDomain: string;
}

export interface IApplicationsModule {
  applications: UserApplication[];
  creditUnions: LenderBranding[];
  lenderId: number | undefined | null;
  isDark: boolean;
  textColor: string;
}

const applicationsModule: Module<IApplicationsModule, any> = {
  namespaced: true,
  state: {
    applications: [],
    creditUnions: [],
    lenderId: 0,
    isDark: true,
    textColor: "#000000",
  },
  mutations: {
    SET_APPLICATIONS(state: IApplicationsModule, applications: UserApplication[]) {
      state.applications = applications;
    },
    SET_CREDIT_UNIONS(state: IApplicationsModule, creditUnions: LenderBranding[]) {
      state.creditUnions = creditUnions;
    },
    SET_LENDER_ID(state: IApplicationsModule, lenderId: number) {
      state.lenderId = lenderId;
    },
    SET_IS_DARK(state: IApplicationsModule, isDark: boolean) {
      state.isDark = isDark;
    },
    SET_CU_MODE(state: IApplicationsModule, lender: LenderBranding) {
      state.lenderId = lender.lenderId;
      console.log("SET_CU_MODE", { document, body: document.body, lender });
      // Determine if page should follow light or dark theme
      if (lender.primaryColor) {
        const parsedHex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(lender.primaryColor);
        const rgb = parsedHex
          ? {
              r: parseInt(parsedHex[1], 16),
              g: parseInt(parsedHex[2], 16),
              b: parseInt(parsedHex[3], 16),
            }
          : null;

        if (rgb !== null) {
          // determine if light or dark theme is needed
          const luminance = Math.round((rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000);

          // Adding else statement just in case client changes. Mainly for testing...
          if (luminance > 118) {
            state.isDark = true;
            document.body.classList.add("cuscd-dark");
            state.textColor = "#000000";
          } else {
            state.isDark = false;
            document.body.classList.remove("cuscd-dark");
            state.textColor = "#ffffff";
          }
        }
      } else {
        // based on default lender color #f7941e
        state.isDark = true;
      }
    },
    SET_TEXT_COLOR(state: IApplicationsModule, hexColor: string) {
      state.textColor = hexColor;
    },
  },
  actions: {
    setApplications({ commit }, applications: UserApplication[]) {
      commit("SET_APPLICATIONS", applications);
    },
    setCreditUnions({ commit }, creditUnions: LenderBranding[]) {
      commit("SET_CREDIT_UNIONS", creditUnions);
    },
    setLenderId({ commit }, lenderId?: number) {
      commit("SET_LENDER_ID", lenderId);
    },
    setCreditUnionColorScheme({ commit }, creditUnion: LenderBranding) {
      commit("SET_CU_MODE", creditUnion);
    },
    setTextColor({ commit }, hexColor: string) {
      commit("SET_TEXT_COLOR", hexColor);
    },
  },
  getters: {
    Branding: (state: IApplicationsModule): LenderBranding | undefined => {
      return state.creditUnions.find((cu: LenderBranding) => cu.lenderId === state.lenderId);
    },
    DefaultTextColor: (state: IApplicationsModule): string => {
      return state.textColor || "#000000";
    },
  },
};

export default applicationsModule;
